module.exports = __webpack_public_path__ + "static/OpenSans-Italic-5a91bee86d96bb237546952ed7279c88.woff2";